import { DateTime } from 'luxon';
import { isEmpty } from 'lodash/fp';
import i18next from 'i18next';

export const parseSelectionToDateFormat = (selection) => {
    if (isEmpty(selection)) {
        return [];
    }
    if (selection.length === 1 && selection[0] instanceof DateTime) {
        return [selection[0]];
    }

    return [DateTime.fromJSDate(selection[0]), DateTime.fromJSDate(selection[1])];
};

export const toISOFormat = (value) =>
    value.set({ milliseconds: 0 }).toISO({
        includeOffset: false,
        suppressMilliseconds: true
    });

export function getDateRangeFromSelectedBars(values, bin) {
    if (isEmpty(values) || !bin) {
        return null;
    }
    const valueFrom = values[0];
    const valueTo = values.length === 1 ? values[0] : values[1];
    const from = valueFrom.startOf(bin.toLowerCase());
    const to = valueTo.endOf(bin.toLowerCase());
    return {
        rangeFrom: from.toISO({ includeOffset: false }),
        rangeTo: to.toISO({ includeOffset: false })
    };
}

export function getDateDomainRange(data) {
    if (isEmpty(data?.columns)) {
        return null;
    }
    const dates = data.columns[0];

    if (!(dates[0] instanceof DateTime)) {
        return null;
    }

    return { min: DateTime.min(...dates).toJSDate(), max: DateTime.max(...dates).toJSDate() };
}

export const getDateRangeLabel = (dateFilter) => {
    const rangeFrom = dateFilter.rangeFrom?.replace('T', ' ');
    const rangeTo = dateFilter.rangeTo?.replace('T', ' ');
    if (rangeFrom && rangeTo) {
        return `${rangeFrom} - ${rangeTo}`;
    } else if (rangeFrom) {
        return `${i18next.t('common:from')} ${rangeFrom}`;
    }
    return `${i18next.t('common:to')} ${rangeTo}`;
};
